
import create from './create'
import createAcenad from './createAcenad'
import fetch from './fetch'
import updateMinute from './updateMinute'
import update from './update'
import deleteService from './delete'
import createBillingRequest from './createBillingRequest'

export default {
  create,
  createAcenad,
  fetch,
  delete: deleteService,
  updateMinute,
  update,
  createBillingRequest,
}


// WEBPACK FOOTER //
// ./src/services/Files/index.js